import memoize from "lodash.memoize";
export const resizeImage = memoize(_ref => {
  let {
    scalar,
    image
  } = _ref;
  // This function should not be called when createImageBitmap is not supported because HTMLImageElement is used higher up
  // eslint-disable-next-line compat/compat
  return createImageBitmap(image, {
    resizeHeight: image.height * scalar,
    resizeWidth: image.width * scalar,
    resizeQuality: "medium"
  });
}, _ref2 => {
  let {
    scalar,
    src,
    width,
    height
  } = _ref2;
  return "".concat(scalar).concat(src).concat(width).concat(height);
});